<template>
  <div id="app">
    <Intro v-if="$store.state.indexUI == 0"/>
    <Page1 v-if="$store.state.indexUI == 1" :showErrorMessage="showValidationMessage[1]" @validated="validated"/>
    <Page2 v-if="$store.state.indexUI == 2" :showErrorMessage="showValidationMessage[2]" @validated="validated"/>
    <Page3 v-if="$store.state.indexUI == 3"/>
    <Results v-if="$store.state.indexUI == 4"/>
    <Nav v-if="$store.state.indexUI >= 1 && $store.state.indexUI <= 3" @validationError="showErrorMessage"/>
  </div>
</template>

<script>
import Intro from '@/components/Intro'
import Page1 from '@/components/Page1'
import Page2 from '@/components/Page2'
import Page3 from '@/components/Page3'
import Results from '@/components/Results'
import Nav from '@/components/Nav'

export default {
  name: 'app',
  components: {
    Intro,
    Page1,
    Page2,
    Page3,
    Results,
    Nav
  },
  data () {
    return {
      showValidationMessage: {
        1: false,
        2: false
      }
    }
  },
  methods: {
    showErrorMessage (payload) {
      this.showValidationMessage[payload] = true
    },
    validated (payload) {
      this.showValidationMessage[payload] = false
    }
  }
}
</script>

<style lang="scss">
@import './scss/main.scss';
#app {
  width: 100%;
  max-width: 653px;
  min-height: 540px;
  margin: 0 auto;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  position: relative;
}
</style>
